import {useSelector} from 'react-redux';
import {useSaveRunfile} from '../../../../../hooks/useSaveRunfile';
import {IElementLikertScale} from '../../../../../incase-domain/elements/question/likertScale';
import {LikertScaleInteractions} from '../../../../../incase-domain/proptypes/runfile';
import {pointsSelector} from '../../../../../store/selectors/runfile.selectors';

function useLikertScaleTry(): (element: IElementLikertScale, elementInteractions: LikertScaleInteractions) => void {
    const points = useSelector(pointsSelector);
    const saveRunfile = useSaveRunfile();

    function handleTry(element: IElementLikertScale, elementInteractions: LikertScaleInteractions): void {
        saveRunfile(
            {
                ...elementInteractions,
                likertScaleAnswer: elementInteractions.likertScaleAnswerClicked,
                answered: true,
            },
            element.id,
            element.slideId,
            points || 0
        );
    }

    return handleTry;
}

export default useLikertScaleTry;
